import { createSelector } from 'reselect'

const pairsFunction = state => state.matchingPairsCt.pairs

export default createSelector(
	[pairsFunction],
	pairs => pairs.filter(pair => !pair.deleted)
)
